// A password field with a show/hide button at its end, for checking what was typed (or pasted)
// before sending it. Everything else is the input's own: pass what an <input> takes.

import { useState, type InputHTMLAttributes } from "react";

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, "type">;

export function PasswordInput(props: Props) {
  const [shown, setShown] = useState(false);
  const testid = (props as { "data-testid"?: string })["data-testid"];
  return (
    <span className="pw-wrap">
      <input
        {...props}
        type={shown ? "text" : "password"}
        autoCapitalize="off"
        autoCorrect="off"
        spellCheck={false}
      />
      <button
        type="button"
        className="pw-toggle"
        aria-label={shown ? "Hide password" : "Show password"}
        aria-pressed={shown}
        title={shown ? "Hide password" : "Show password"}
        data-testid={testid ? `${testid}-toggle` : undefined}
        onMouseDown={(e) => e.preventDefault()} // the field keeps focus (and its caret)
        onClick={() => setShown((s) => !s)}
      >
        {shown ? <EyeOff /> : <Eye />}
      </button>
    </span>
  );
}

const Eye = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M1.5 10S4.5 4 10 4s8.5 6 8.5 6-3 6-8.5 6S1.5 10 1.5 10Z" />
    <circle cx="10" cy="10" r="2.6" />
  </svg>
);

const EyeOff = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M8.2 4.2A8.8 8.8 0 0 1 10 4c5.5 0 8.5 6 8.5 6a14.6 14.6 0 0 1-2.2 3M5.1 5.6C2.8 7.2 1.5 10 1.5 10s3 6 8.5 6a8.4 8.4 0 0 0 4-1" />
    <path d="M8.2 8.3a2.6 2.6 0 0 0 3.5 3.5M2.5 2.5l15 15" />
  </svg>
);
